import axios from "axios";
import { toast } from "react-toastify";
import {
  SALARY_FETCH_REQUEST,
  SALARY_FETCH_SUCCESS,
  SALARY_FETCH_FAILURE,
} from "../../types/HrTypes";

export const generateSalarySheet = (params) => async (dispatch) => {
  dispatch({ type: SALARY_FETCH_REQUEST });
  try {
    const { data } = await axios.post("hr/salary/generate", params);
    dispatch({ type: SALARY_FETCH_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const msg = error.response?.data?.message || error.message;
    dispatch({ type: SALARY_FETCH_FAILURE, payload: msg });
    toast.error(msg);
  }
};

export const getWorkerLedger = (workerId, from, to) => async () => {
  try {
    const { data } = await axios.get(`hr/salary/worker/${workerId}`, { params: { from, to } });
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const approveSandwich = (flagId) => async () => {
  try {
    const { data } = await axios.put(`hr/salary/sandwich/${flagId}/approve`);
    toast.success("Sandwich leave approved (deduction applied)");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const waiveSandwich = (flagId, reason) => async () => {
  try {
    const { data } = await axios.put(`hr/salary/sandwich/${flagId}/waive`, { reason });
    toast.success("Sandwich leave waived");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const saveSalarySheet = (payload) => async () => {
  try {
    const { data } = await axios.post("hr/salary/save", payload);
    toast.success(data.message || "Salary sheet saved");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const getSavedSalarySheet = (year, month) => async () => {
  try {
    const { data } = await axios.get("hr/salary/saved", { params: { year, month } });
    return data;
  } catch (error) {
    return [];
  }
};

export const settleWorkerSalary = (payload) => async () => {
  try {
    const { data } = await axios.post("hr/salary/settle", payload);
    toast.success(data.message || "Salary settled");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const unsettleWorkerSalary = (payload) => async () => {
  try {
    const { data } = await axios.post("hr/salary/unsettle", payload);
    toast.success(data.message || "Settlement reversed");
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return null;
  }
};
